<script>
export default {
  name: 'TwInput',
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'md'
    },
    smallLabel: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue', 'update', 'blur'],
  data() {
    return {
      Validated: null,
    }
  },
  computed: {
    classes() {
      return [
        'block w-full rounded-lg border-0 text-gray-900 ring-1 ring-inset placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-gray-800',
        {'': this.size === 'lg'},
        {'sm:leading-6 py-2 min-h-[44px]': this.size === 'md'},
        {'sm:text-xs sm:leading-6 py-1': this.size === 'sm'},
        {'ring-green-500 bg-green-50 text-green-900' : this.required && this.Validated === true},
        {'ring-red-500 bg-red-50 text-red-700' : this.required && this.Validated === false},
        'ring-gray-300 hover:ring-gray-400'
      ]
    }
  },
  methods: {
    focus() {
      this.Validated = null
    },
    blur() {
      this.$emit('blur')
      if(this.modelValue && this.modelValue.length > 0) {
        this.Validated = true
      }
      else {
        this.Validated = false
      }
    }
  }
}
</script>

<template>
  <div class="w-full">
    <label v-if="label || $slots.label" :for="id" class="form-label"> <slot name="label">{{ label }}</slot> </label>
    <div v-if="smallLabel || $slots.smallLabel" class="form-label-sm">
      <slot name="smallLabel">
        {{ smallLabel }}
      </slot>
    </div>
    <input
      :id="id"
      :required="required"
      :readonly="disabled" :value="modelValue" type="text" :name="id" :autocomplete="id" :class="classes" :placeholder="placeholder"
      @focus="focus" @blur="blur" @input="$emit('update:modelValue', $event.target.value)"
    >
  </div>
</template>

<style scoped>

</style>
